import http from '@/helpers/Http';

export default {
    namespaced: true,
    state: {
        items: {
            data: [],
            links: {},
            meta: {}
        }
    },
    getters: {
        items: state => state.items
    },
    mutations: {
        setItems(state, items) {
            state.items = items;
        }
    },
    actions: {
        async index({ commit, rootState }) {
            const response = await http.get('admin/logs', {params: rootState.route.query});

            commit('setItems', response.data);            

            return response;
        }
    }
}